import { UserModel } from "../../modules/auth";

export const isAuthorizedUser = (auth: UserModel | undefined, permission) => {
    if (auth === undefined) return false;
    return auth.permissions.some((userPermission) => userPermission === permission);
}

export const userHasMainScope = (auth: UserModel | undefined, permissions: string[]) => {
    if (auth === undefined) return false;
    const mainScopes = Array.from(new Set(auth.permissions.map(perm => perm.split('.')[0])));
    return permissions.some(perm => mainScopes.includes(perm));
}